export function enFecha(iso: string | undefined): string {
  if (!iso) {
    return '';
  }
  const [anio, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${anio}`;
}

export function enMomento(iso: string | undefined): string {
  if (!iso) {
    return '';
  }
  const fecha = new Date(iso);
  const dosCifras = (n: number) => String(n).padStart(2, '0');
  return (
    `${dosCifras(fecha.getDate())}/${dosCifras(fecha.getMonth() + 1)}/${fecha.getFullYear()}` +
    ` ${dosCifras(fecha.getHours())}:${dosCifras(fecha.getMinutes())}`
  );
}

export function hoy(): string {
  return enIso(new Date());
}

export function hace(dias: number): string {
  const fecha = new Date();
  fecha.setDate(fecha.getDate() - dias);
  return enIso(fecha);
}

function enIso(fecha: Date): string {
  const dosCifras = (n: number) => String(n).padStart(2, '0');
  return `${fecha.getFullYear()}-${dosCifras(fecha.getMonth() + 1)}-${dosCifras(fecha.getDate())}`;
}
